import { RouterProvider } from 'react-router';

import { PageProvider } from '@/hooks/page/PageContext';
import { NotificationProvider } from '@/providers/Notification';
import { ThemeProvider } from '@/providers/Theme';
import { UserProvider } from '@/providers/User';
import getRouter from '@/router/Router';

function App() {
  const router = getRouter();

  return (
    <UserProvider>
      <ThemeProvider>
        <NotificationProvider>
          <PageProvider>
            <RouterProvider router={router} />
          </PageProvider>
        </NotificationProvider>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
